import { IPublicClientApplication, LogLevel, PublicClientApplication} from '@azure/msal-browser';

export function MSALInstanceFactory(): IPublicClientApplication {

    // Shell/empty PCA to initially initialize MSAL. 
    // We will configure it with actual values later, before the redirect and after the redirect.
    return new PublicClientApplication({
        auth: {
            clientId: '',
            authority: '',
            redirectUri: ''
        },
        cache: {
            cacheLocation: 'SessionStorage', 
        },
           system: {
               loggerOptions: {
                   loggerCallback: (level, message, containsPii) => {
                       if (containsPii) {
                           return;
                       }
                       switch (level) {
                           case LogLevel.Error:
                               console.error(`[MSAL]`, message);
                               return;
                           case LogLevel.Warning:
                               console.warn(`[MSAL]`, message);
                               return;
                           case LogLevel.Info:
                               console.info(`[MSAL]`, message);
                               return;
                           case LogLevel.Verbose:
                               console.debug(`[MSAL]`, message);
                               return;
                       }
                   },
                   logLevel: LogLevel.Verbose
               }
           }

    });
}
